import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenesysLaneButtonsComponent } from './genesys-lane-buttons.component';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  declarations: [
    GenesysLaneButtonsComponent
  ],
  imports: [
    CommonModule,
    SvgIconModule,
    TooltipModule,
    TranslateModule
  ],
  exports: [
    GenesysLaneButtonsComponent
  ]
})
export class GenesysLaneButtonsModule { }
